import TabPanelDiv from '@components/shared/TabPanelDiv';
import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';

type HelpTabsProps = {
  tabs: { label: string; component: React.ReactNode }[];
};

export const HelpTabs = (props: HelpTabsProps) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box>
      <Tabs
        sx={{
          textTransform: 'none',
          marginLeft: '-20px',
          marginRight: '-20px',
        }}
        onChange={(_, value) => setTabIndex(value as number)}
        value={tabIndex}
        className="help-tabs"
        TabIndicatorProps={{
          sx: {
            backgroundColor: 'transparent',
          },
        }}
      >
        {props.tabs.map(tab => (
          <Tab label={tab.label} key={tab.label} />
        ))}
      </Tabs>

      <div className="tab-content">
        {props.tabs.map((tab, index) => (
          <TabPanelDiv value={tabIndex} index={index} key={tab.label}>
            {tab.component}
          </TabPanelDiv>
        ))}
      </div>
    </Box>
  );
};
